export default __webpack_public_path__ + "static/media/metamask.a28d3a53.png";